import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import Me from '@/views/Me'
import MoreInfo from '@/views/MoreInfo'
import SpareTimeComponent from '@/components/SpareTimeComponent'
import Career from '@/views/Career'
import Certificates from '@/views/Certificates'
import PrivateProsjects from '@/views/PrivateProsjects'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/more-info',
    name: 'MoreInfo',
    component: MoreInfo,
    children: [
      {path: 'fritid', component: SpareTimeComponent},
      {path: 'karriere', component: Career},
      {path: 'sertifikater', component: Certificates},
      {path: 'prosjekter', component: PrivateProsjects},
      {path: 'me', component: Me},  
    ]
  },

  
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
